import React from "react";
import { useAppDispatch, useAppSelector } from "./store/hooks";
import {
    selectActiveStructure,
    selectClientAssetData,
    selectClientAssetDataDatasetStatus,
    selectClientAssetDataDatasetVersionDttm,
    setActiveStructureByName,
} from "./store/reducers/deviceLinkingAppStoreSlice";
import DatasetDerivedList from "./DatasetDerivedList";

type StructureListProps = {
    className?: string;
};

export default function StructureList(props: StructureListProps): JSX.Element {
    const dispatch = useAppDispatch();
    const dataset = useAppSelector(selectClientAssetData);
    const datasetStatus = useAppSelector(selectClientAssetDataDatasetStatus);
    const datasetVersion = useAppSelector(selectClientAssetDataDatasetVersionDttm);

    const activeObjectStructure = useAppSelector(selectActiveStructure);
    return (
        <DatasetDerivedList
            className={props.className}
            dataNotYetLoadedMessage="No data loaded. Select a Client & Project to continue"
            emptyListMessage="No structures in dataset"
            errorMessage="Error loading data"
            datasetStatus={datasetStatus}
            datasetType={dataset?.meta?.dataset_type || ""}
            datasetVersion={datasetVersion || ""}
            selectObject={(structure) => structure && dispatch(setActiveStructureByName(structure.structure_name))}
            isActiveObject={(obj) => activeObjectStructure?.structure_name === obj.structure_name}
            objectList={dataset?.data.structures || []}
            extractObjectKey={(structure) => structure.structure_name}
            extractObjectLabel={(structure) => structure.structure_name}
        />
    );
}
